"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboDefaultSubsidyForAttempt = void 0;
exports.getComboDefaultSubsidy = getComboDefaultSubsidy;
const constants_1 = require("@daytrip/constants");
const assignationOffer_1 = require("../assignationOffer");
const getComboSavingsSubsidy_1 = require("./getComboSavingsSubsidy");
const DEFAULT_EARLY_ASSIGNATION_BASE_DISCOUNT = 2;
const DEFAULT_EARLY_ASSIGNATION_DISCOUNT = 6;
const DEFAULT_TRIP_DURATION_DISCOUNT_MAX = 5;
const GOOD_COVERAGE_DRIVER_COUNT = 11;
function getComboDefaultSubsidy({ isPersonal, savingsPercentage, savings, orders, comboConnections, comboDiscountCoefficient, additionalDiscount, }) {
    const totalTravelTimeMinutes = orders.reduce((acc, order, i) => {
        const connectionTime = comboConnections.at(i)?.durationInMinutes ?? 0;
        // Travel estimates are defined in 99%+ cases, so this assumption has a minor impact
        if (!order.travelEstimates) {
            return acc + 180 + connectionTime;
        }
        return acc + order.travelEstimates.travelTimeMinutes + (order.travelEstimates.timeAtLocationsMinutes || 0) + connectionTime;
    }, 0);
    // Cap combo subsidy at 45% savings level (higher levels possible due to different regions savings)
    const savingsCap = Math.max(1, savingsPercentage / 45);
    const defaultComboSubsidy = Math.round((0, getComboSavingsSubsidy_1.getComboSavingsSubsidy)({
        isPersonal,
        savingsPercentage,
        savings: savings / savingsCap,
    }) * comboDiscountCoefficient);
    const comboDurationHours = (orders[orders.length - 1].arrivalAtMs - orders[0].departureAtMs) / constants_1.HOUR_IN_MILLISECONDS;
    // With time greater than 16 hours, it's assumed that combo is a multi-day trip, while greater than 36 it's assumed to have two sleepovers
    const comboDays = comboDurationHours > 36 ? 3 : comboDurationHours > 16 ? 2 : 1;
    const totalTripsPrice = orders.reduce((acc, order) => acc + (order.price ?? 0), 0) + defaultComboSubsidy;
    const comboDynamicSubsidy = (0, assignationOffer_1.getDefaultSubsidyForOffer)({
        departureAtUtc: new Date(orders[0].departureAtMs),
        // Discount related to trip duration is applied on per-day basis in single trips, time is subtracted to get similar outcomes
        tripDurationInMinutes: totalTravelTimeMinutes / comboDays,
        vehiclePrice: totalTripsPrice,
        // Assume good driver coverage for combos for performance reasons (most combos are in well-covered areas)
        fittingDriversCount: GOOD_COVERAGE_DRIVER_COUNT,
        baseDiscount: DEFAULT_EARLY_ASSIGNATION_BASE_DISCOUNT,
        earlyAssignationDiscount: DEFAULT_EARLY_ASSIGNATION_DISCOUNT,
        tripDurationDiscountMax: DEFAULT_TRIP_DURATION_DISCOUNT_MAX,
        additionalDiscount,
    });
    return comboDynamicSubsidy + defaultComboSubsidy;
}
const getComboDefaultSubsidyForAttempt = (recommendedSubsidy, failedAttempts) => {
    if (failedAttempts === 1) {
        return Math.round(recommendedSubsidy * 0.667);
    }
    if (failedAttempts > 1) {
        return Math.round(recommendedSubsidy * 0.333);
    }
    return recommendedSubsidy;
};
exports.getComboDefaultSubsidyForAttempt = getComboDefaultSubsidyForAttempt;
//# sourceMappingURL=getComboDefaultSubsidy.js.map